
import "justifiedGallery"
import "justifiedGallery/dist/css/justifiedGallery.css"

class GalleryBuilder {

  constructor(galleryTarget) {
    this.galleryTarget = galleryTarget;
  }

  setup() {

    this.galleryTarget.justifiedGallery({
      rowHeight : 300
    });
  }
};

var buildGallery = function() {
  var builder = new GalleryBuilder($(this));
  builder.setup();

  return builder;
};

export default buildGallery;
